import React, {useEffect, useState} from "react";
import {RouteHelper} from "../../route/RouteHelper";
import {useNavigate, useParams} from "react-router-dom";
import {TransactionService} from "../../serverService/transactionService/TransactionService";
import {Skeleton} from "@mui/material";
import {paymentStatus} from "./TransactionsList";
import ShowOrderInfo from "../../component/showOrderInfo/ShowOrderInfo";

import {css} from "@emotion/css";
import {
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoChipTypes,
    RaikoCustomSimpleChip,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoLabel,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage,
    RaikoTableTitleContainer,
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export const TransactionDetail = () => {

    const {id: transactionId = -1} = useParams()
    const service = new TransactionService()

    const [transactionInfo, setTransactionInfo] = useState()
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (transactionId && transactionId > 0) {
            getDataFromServer();
        }
    }, [transactionId]);

    function getDataFromServer() {
        setLoading(true)
        service.getTransactionInformation(transactionId)
            .then(response => {
                setTransactionInfo(response)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setLoading(false)
        })
    }


    const navigate = useNavigate()

    function ignoreOnChange() {
        //
    }

    return (
        <>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.TransactionsList.name,
                                    RouteHelper.TransactionsList.globalUrl
                                )
                            ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1);
                            }}/>
                    </RaikoFlexFirstChildGrowOne>

                    <RaikoBaseCardContainer>
                        <div className={css`
                          display: flex;
                          flex-direction: row;
                          width: 100%;
                          justify-content: space-between;
                          align-items: center;
                        `}>
                            <RaikoLabel text={"وضعیت پرداخت"}/>
                            {
                                loading ?
                                    <Skeleton
                                        variant="rectangular"
                                        className={css`
                                          padding: 16px;
                                          min-height: 40px;
                                          width: 72px;`}
                                    /> :
                                    transactionInfo.status === paymentStatus.SUCCESS.id ?
                                        <RaikoCustomSimpleChip
                                            title={paymentStatus.SUCCESS.name}
                                            type={RaikoChipTypes.success}/> :
                                        transactionInfo.status === paymentStatus.UN_SUCCESS.id ?
                                            <RaikoCustomSimpleChip
                                                title={paymentStatus.UN_SUCCESS.name}
                                                type={RaikoChipTypes.error}/> :
                                            <RaikoCustomSimpleChip
                                                title={paymentStatus.AWAITING_FOR_PAYMENT.name}
                                                type={RaikoChipTypes.warning}/>


                            }
                        </div>

                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer title={"جزئیات تراکنش"}>
                            {
                                !loading && transactionInfo ?
                                    <RaikoGridThreeColumn>
                                        <RaikoSimpleInputOutlined
                                            labelText={"مبلغ (تومان)"}
                                            disabled setValue={ignoreOnChange}
                                            value={convertCurrencyFormatPositiveNegative(transactionInfo.amount)}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"تاریخ"}
                                            disabled setValue={ignoreOnChange}
                                            value={convertUniversalDateTimeToPersianDateTime(transactionInfo.createdAtDate)}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"زمان"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.createdAtPersianTime}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"شناسه پرداخت"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.serial}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"شناسه پرداخت"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.serial}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"شناسه درگاه"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.gatewaySerial}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"ip"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.ip}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"شناسه داخلی درگاه"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.paymentGatewayId}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"عنوان داخلی درگاه"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.paymentGatewayTitle}/>
                                    </RaikoGridThreeColumn>
                                    : <RaikoGridThreeColumn>
                                        {
                                            [...Array(6)].map(item => {
                                                return <Skeleton
                                                    key={item}
                                                    variant="rectangular"
                                                    className={css`
                                                      padding: 16px;
                                                      min-height: 50px;
                                                      width: 100%;`}
                                                />
                                            })
                                        }
                                    </RaikoGridThreeColumn>


                            }

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جزئیات پرداخت کننده"}
                            hasActionButton
                            actionButtonTitle={"جزئیات کاربر"}
                            actionButtonOnclick={_ => {
                                if (transactionInfo && transactionInfo.payerId) {
                                    navigate(RouteHelper.UserInformation.globalUrl.replace(":id", transactionInfo.payerId))
                                }
                            }}
                        >
                            {
                                !loading && transactionInfo ?
                                    <RaikoGridThreeColumn>
                                        <RaikoSimpleInputOutlined
                                            labelText={"شناسه داخلی کاربر"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.payerId}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"نام"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.payerFirstName}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"نام خانوادگی"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.payerLastName}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"شماره همراه"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.payerPhoneNumber}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"کد ملی"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.payerNationalCode}/>
                                    </RaikoGridThreeColumn>
                                    : <RaikoGridOneColumn>
                                        {
                                            [...Array(6)].map(item => {
                                                return <Skeleton
                                                    key={item}
                                                    variant="rectangular"
                                                    className={css`
                                                      padding: 16px;
                                                      min-height: 50px;
                                                      width: 100%;`}
                                                />
                                            })
                                        }
                                    </RaikoGridOneColumn>


                            }

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جزئیات خطا"}
                        >
                            {
                                !loading && transactionInfo ?
                                    <RaikoGridOneColumn>
                                        <RaikoSimpleMultiLineInputOutlined
                                            labelText={"متن خطا"}
                                            setValue={ignoreOnChange}
                                            disabled
                                            value={transactionInfo.errorMessage ? transactionInfo.errorMessage : "بدون خطا"}
                                        />
                                    </RaikoGridOneColumn>
                                    : <RaikoGridOneColumn>
                                        <Skeleton
                                            variant="rectangular"
                                            className={css`
                                              padding: 16px;
                                              min-height: 50px;
                                              width: 100%;`}
                                        />
                                    </RaikoGridOneColumn>


                            }

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>


                    {
                        !loading && transactionInfo ?
                            <RaikoBaseCardContainer>
                                <RaikoGridOneColumn>
                                    {
                                        transactionInfo.actions.map((item, index) => {
                                            if (item.type === "TOUR_RESERVATION") {
                                                return <RaikoSectionContainer
                                                    title={"جزئیات سفارش خرید تور"}
                                                    hasActionButton
                                                    actionButtonTitle={"جزئیات دوره برگزاری"}
                                                    actionButtonOnclick={_ => {
                                                        navigate(RouteHelper.CoursesHeldDetails.globalUrl.replace(":id", item.tourPeriodId))

                                                    }}
                                                >
                                                    <RaikoGridOneColumn>
                                                        <RaikoGridTwoColumn>
                                                            <RaikoSimpleInputOutlined
                                                                labelText={"شناسه دوره برگزاری تور"}
                                                                setValue={ignoreOnChange}
                                                                disabled
                                                                value={item.tourPeriodId}/>
                                                            <RaikoSimpleInputOutlined
                                                                labelText={"عنوان دوره برگزاری تور"}
                                                                setValue={ignoreOnChange}
                                                                disabled
                                                                value={item.title}/>
                                                        </RaikoGridTwoColumn>
                                                        <RaikoTableTitleContainer
                                                            title={"مسافران"}
                                                            amount={item.items.length}
                                                        />
                                                        {
                                                            item.items.map((passenger, passengerIndex) => {
                                                                return <ShowOrderInfo
                                                                    key={index}
                                                                    ages={passenger.title}
                                                                    firstName={passenger.firstName}
                                                                    lastName={passenger.lastName}
                                                                    phoneNumber={passenger.phoneNumber}
                                                                    nationalCode={passenger.nationalCode}
                                                                    gender={passenger.gender}
                                                                    birthdate={passenger.birthdate}
                                                                    totalPaidAmount={passenger.totalPaidAmount}
                                                                />
                                                            })
                                                        }
                                                    </RaikoGridOneColumn>
                                                </RaikoSectionContainer>
                                            }
                                        })
                                    }
                                </RaikoGridOneColumn>

                            </RaikoBaseCardContainer>
                            : <></>
                    }
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}